import * as TYPE from "../types";

const initialState = {
  current: "",
  loggedIn: false,
  loading: false,
  err: false,
  msg: null,
};

export const loginReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case TYPE.EMAIL_DOES_NOT_EXIST:
      return {
        ...state,
        current: "signup",
      };
    case TYPE.EMAIL_EXISTS:
      return {
        ...state,
        current: "password",
        user: true,
      };
    case TYPE.EMAIL_VERIFICATION_PENDING:
      return {
        ...state,
        current: "signup-otp",
      };
    case TYPE.EMAIL_ERROR:
      return {
        ...state,
        err: true,
      };
    case TYPE.SIGNIN_SUCCESS:
      return {
        ...state,
        loggedIn: true,
      };
    case TYPE.SIGNIN_FAIL:
      return {
        ...state,
        err: true,
        msg: action.payload,
      };
    case TYPE.OTP_VERIFICATION_FAIL:
      return {
        ...state,
        err: true,
        msg: action.payload,
      };
    case TYPE.LOGOUT:
      return {
        ...state,
        current: "emailCheck",
        loggedIn: false,
      };
    case TYPE.PASSWORD_RESET_SUCCESS:
      return {
        ...state,
        current: "emailCheck",
        loggedIn: false,
      };
    case TYPE.OTP_SENT_ERROR:
      return {};
    default:
      return state;
  }
};
